import { inject, Injectable } from '@angular/core';
import { TaskWorkspaceStore } from '../../core/h3ml/state/task-workspace-store';
import { ToolName } from '../tools-names';

@Injectable()
export class ToolsHelperService {
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  /**
   * @param outputName - The name of the output to get the allowed tools for
   * @returns The name of the tools that are allowed for the given output,
   * configured in the projects output meta data
   */
  getAllowedTools(outputName: string): ToolName[] {
    const output = this.taskWorkspaceStore
      .state()
      .project.outputs.find(
        (projectOutput) => projectOutput.name === outputName,
      );

    if (output?.meta && 'available_tools' in output.meta) {
      return output.meta.available_tools;
    }

    return [];
  }
}
